import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from 'helpers/gtm';

/**
 * Fires a GA4 `page_view` event on every route change. Must be used inside a
 * component rendered by the router (so `useLocation` is available).
 *
 * Only the pathname is sent (query strings are dropped) to avoid leaking any
 * patient/record ids that may live in URL params.
 */
const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);
};

export default usePageTracking;
